import { GeofenceType } from './geofence-type';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

import { AbstractModel } from '@uzurv/core';
import { GeoPoint } from './geo-point';
import { GeofenceCondition } from './geofence-condition';
@inheritSerialization(AbstractModel)
export class Geofence extends AbstractModel {
  @autoserialize
  transitProgramId: number;

  @autoserializeAs(GeoPoint)
  points: Array<GeoPoint>;

  @autoserializeAs(GeofenceCondition)
  geofenceCondition: GeofenceCondition;

  @autoserializeAs(GeofenceType)
  geofenceType: GeofenceType;

  @autoserializeAs(GeofenceType)
  static OnSerialized(instance: AbstractModel, json: any): void {
    super.OnSerialized(instance, json);
  }

  static OnDeserialized(instance: AbstractModel, json: any): void {
    super.OnDeserialized(instance, json);
  }
}
